import { mapGetters, mapActions } from 'vuex';
import TabLoader from '@/components/TabLoader/index.vue';
import AccessoriesSection from '@/components/AccessoriesSection/index.vue';

export default {
  name: 'Accessories',
  data() {
    return {
      className: 'app__product__accessories',
    };
  },
  components: {
    TabLoader,
    AccessoriesSection,
  },
  computed: {
    ...mapGetters({
      categoryNames: 'getCategoryNames',
      accessoriesLoading: 'getAccessoriesLoading',
      expandSectionText: 'getExpandSection',
      collapseSectionText: 'getCollapseSection',
      tabNoAccessories: 'getTabNoAccessories',
      tabErrorAccessories: 'getAccessoriesTabError',
      showNoAccessoriesText: 'getShowNoAccessoriesText',
      errorAccessoriesText: 'getErrorAccessoriesText',
      activeAccessories: 'getActiveAccessories',
      productActiveTabId: 'getProductActiveTabId',
    }),
  },
  watch: {
    productActiveTabId() {
      this.callAccessories();
    },
  },
  created() {
    this.callAccessories();
  },
  methods: {
    ...mapActions([
      'callAccessories',
      'setAllSections',
    ]),
  },
};
